<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="70px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="月份" prop="monthCodeQuery">
            <el-date-picker
              v-model="searchForm.monthCodeQuery"
              unlink-panels
              type="month"
              value-format="yyyyMM"
              @change="onSearch"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="姓名" prop="userName">
            <el-input v-model.trim="searchForm.userName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="工号" prop="workNo">
            <el-input v-model.trim="searchForm.workNo" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="类型" prop="processType">
            <el-select v-model="searchForm.processType" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in ['修片', '渲染', '修片(模特)']" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            {{ scope.row[item.columnName] | cellValFormat }}
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import moment from "moment";
export default {
  name: "photographySalaryAccounting",
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "newProductPictureRetouchSumInfo",
      columnData: [],
      loading: false,
      searchForm: {
        monthCodeQuery: "",
        userName: "",
        workNo: "",
        processType: "",
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      productTypeList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.init();
      });
    },
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "monthCodeQuery", //月份
          val: this.searchForm.monthCodeQuery ? this.searchForm.monthCodeQuery : "",
          op: "=",
        },
        {
          attributeName: "userName", //姓名
          val: this.searchForm.userName ? this.searchForm.userName : "",
          op: "like",
        },
        {
          attributeName: "workNo", //工号
          val: [this.searchForm.workNo ? this.searchForm.workNo : ""],
          op: "in",
        },
        {
          attributeName: "processType", //类型
          val: [this.searchForm.processType ? this.searchForm.processType : ""],
          op: "in",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    //获取配置页面的产品类型
    getProductTypeList() {
      let data = { ...this.currencyForm };
      data.reportCode = "newProductShootingAccountingConfig";
      data.groupAttr = "productType";
      data.hasCount = "Y";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.productTypeList = data;
      });
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != "图片"); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.getProductTypeList();
    this.columns();
  },
};
</script>

<style lang="stylus" scoped></style>
